// extracted by mini-css-extract-plugin
module.exports = {"container":"MyAccountLink_container__1szZ1","isLogged":"MyAccountLink_isLogged__drXC6","navLink":"MyAccountLink_navLink__38EOx","dropdown":"MyAccountLink_dropdown__11szS"};